import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Mail icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Mail } from '@sravni/design-system-icons'
 *
 * <Mail />
 * ```
 */
var Mail = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Mail", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.988 5.447c0-.018.013-.036.012-.054l-4.883 4.705 4.877 4.554c.003-.033-.006-.066-.006-.099V5.447ZM12.372 10.821l-1.993 1.918a.52.52 0 0 1-.717.006l-1.988-1.852-4.909 4.73c.12.044.248.077.382.077h13.74c.2 0 .387-.06.55-.151l-5.065-4.728Z", fill: "currentColor" }),
    React.createElement("path", { d: "m10.012 11.646 7.451-7.179a1.13 1.13 0 0 0-.575-.167H3.148c-.275 0-.526.106-.722.269l7.586 7.077ZM2 5.622v8.931c0 .103.024.201.05.296l4.847-4.668L2 5.62Z", fill: "currentColor" }))); });

export { Mail };
//# sourceMappingURL=Mail.js.map
